import * as React from 'react';
import { observer } from 'mobx-react';
import { configConsumer } from '@estee/elc-service';
import { Accordion, LabelSlide } from '@estee/elc-accordion';
import { mergeComponentConfigs } from '~utils/ConfigUtils';
import { classes } from '../../utils/Classes';
import { PRODUCT_ACCORDION } from '~constants/DataTestIdAttributes';

interface IProductAccordionConfig {
    gridAccordionIconType?: string;
    accordionDefaultOpen: boolean;
    accordionTitle: string;
    accordionSubtext: string;
}

export interface IProductAccordion {
    config: IProductAccordionConfig;
    children: JSX.Element;
    onChange?(openIndex: number): void;
}

export const ProductAccordion = configConsumer([
    'gridAccordionIconType',
    'accordionDefaultOpen',
    'accordionTitle',
    'accordionSubtext'
])(
    observer(function ProductAccordion(props: IProductAccordion) {
        const productAccordionClassNames = classes('product-accordion');
        const productAccordionLabelClassNames = classes('product-accordion-label');
        const config = mergeComponentConfigs<IProductAccordionConfig>(props);

        const {
            gridAccordionIconType: iconType,
            accordionDefaultOpen,
            accordionTitle = '',
            accordionSubtext = ''
        } = config;
        const { onChange } = props;

        const openIndex = accordionDefaultOpen ? 0 : -1;

        return (
            <Accordion
                className={productAccordionClassNames}
                openIndex={openIndex}
                onChange={onChange}
                dataTestId={PRODUCT_ACCORDION}
            >
                <LabelSlide
                    className={productAccordionLabelClassNames}
                    id={accordionTitle}
                    title={accordionTitle}
                    iconType={iconType}
                >
                    {accordionSubtext}
                    {props.children}
                </LabelSlide>
            </Accordion>
        );
    })
);
